// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__14xiX","text":"SelectPayment_text__2nqvN","title":"SelectPayment_title__1i_A3","btn":"SelectPayment_btn__7RyIN"};